import { colors } from '@microfrontends/react-components'
import styled from 'styled-components'

export const PreviewJobStatusWrapper = styled.div`
    z-index: 100;
`

export const PreviewJobSeekingStatus = styled.div`
    background: #fff;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 8px;
    filter: drop-shadow(0px 2px 8px rgba(51, 51, 51, 0.15));
    min-width: 560px;
    @media screen and (max-width: 768px) {
        min-width: 100%;
    }
    &::before {
        content: '';
        width: 0;
        height: 0;
        border-left: 12px solid transparent;
        border-right: 12px solid transparent;
        border-top: 12px solid #fff;
        position: absolute;
        bottom: -10px;
        left: 0;
        right: 0;
        margin: auto;
        filter: drop-shadow(0px 2px 8px rgba(51, 51, 51, 0.15));
    }
`

export const PreviewUserInfo = styled.div`
    margin-top: 8px;
    padding: 8px 16px;
    border-radius: 12px;
    border: 1px solid ${colors.grey[90]};
    display: flex;
`

export const UserAvatar = styled.img`
    width: 60px;
    height: 60px;
    border-radius: 100%;
`

export const UserInfo = styled.div`
    margin-left: 16px;
`

export const PreviewTitle = styled.div`
    display: flex;
    height: 32px;
    align-items: center;
    justify-content: space-between;
    p {
        width: calc(100% - 36px);
    }
`

export const IconButton = styled.span`
    margin-left: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    > svg {
        vertical-align: top;
    }
    &:hover {
        svg path {
            fill: #333;
        }
    }
`
